var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"clipboardSnackbar",staticClass:"clipboard-snackbar p-2 bg-dark"},[_c('p',{staticClass:"headline m-0 text-center text-white"},[_vm._v("\n    クリップボードにコピーしました。\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }